import type { UseQueryResponse } from '@urql/vue';
import { computed, type Ref } from 'vue';

export const graphQlResponseWithDefaults = <T, U>(params: {
  queryResponse: UseQueryResponse<U>;
  data: Ref<T | undefined>;
  fetching?: Ref<boolean>;
  error?: Ref<{ message: string } | null>;
}): {
  data: Ref<T | undefined>;
  fetching: Ref<boolean>;
  error: Ref<{ message: string } | null>;
} => {
  const {
    queryResponse,
    data,
    fetching: fetchingOverride,
    error: errorOverride,
  } = params;

  const fetching = fetchingOverride ?? queryResponse.fetching;
  const error =
    errorOverride ??
    computed(() =>
      queryResponse.error.value?.message
        ? { message: queryResponse.error.value.message }
        : null,
    );

  return { data, fetching, error };
};
